import {
	Collapsible,
	CollapsibleContent,
	CollapsibleTrigger,
} from "@radix-ui/react-collapsible";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";
import {
	SidebarMenuButton,
	SidebarMenuItem,
	SidebarMenuSub,
	SidebarMenuSubButton,
	SidebarMenuSubItem,
	useSidebar,
} from "@/components/ui/sidebar";
import { NavMainItem } from "../Interface/NavBar";
import { NavItemIcon } from "./nav-icon";

// Component for rendering collapsible navigation links with sub-menus
export function CollapsibleNavItem({ item }: { item: NavMainItem }) {
	const { state } = useSidebar();

	const button =
		state === "collapsed" ? (
			<SidebarMenuButton asChild tooltip={item.title}>
				<Link to={item.url}>
					<NavItemIcon icon={item.icon} /> <span>{item.title}</span>
				</Link>
			</SidebarMenuButton>
		) : (
			<CollapsibleTrigger asChild>
				<SidebarMenuButton tooltip={item.title}>
					<NavItemIcon icon={item.icon} />
					<span>{item.title}</span>
					<ChevronRight className="ml-auto transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90" />
				</SidebarMenuButton>
			</CollapsibleTrigger>
		);

	return (
		<Collapsible
			asChild
			defaultOpen={item.isActive}
			className="group/collapsible"
		>
			<SidebarMenuItem>
				{button}

				<CollapsibleContent>
					<SidebarMenuSub>
						{item.items?.map((subItem: NavMainItem) => (
							<SidebarMenuSubItem key={subItem.title}>
								<SidebarMenuSubButton asChild>
									<Link to={subItem.url}>
										<span>{subItem.title}</span>
									</Link>
								</SidebarMenuSubButton>
							</SidebarMenuSubItem>
						))}
					</SidebarMenuSub>
				</CollapsibleContent>
			</SidebarMenuItem>
		</Collapsible>
	);
}
